import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class WalletTransactionHistoryService {

    constructor(private _http: HttpClient) { }
    gettransactionhistory(data) {
        return this._http.post(environment.api_url+'admin/transaction/history', data);
    }

}
